import * as actionTypes from '../actionTypes/editJournalForm';
import { showError } from '../../../components/common/alerts/alerts';

const editJournalForm = {
  setTemplateType: () => ({
    type: actionTypes.SET_TEMPLATE_TYPE,
    payload: { templateType: null },
  }),

  // TODO: utilise this function for handling errors across wisedoc
  fetchInitialStateFailed: () => ({
    type: actionTypes.FETCH_INITIAL_STATE_FAILED,
    error: true,
  }),

  changeBasicInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_BASIC_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeParagraphComponentInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_PARAGRAPH_COMPONENT_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeSlateEditorsValue: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.CHANGE_SLATE_EDITORS_VALUE,
      payload: { ...params },
    };
    dispatch(actionData);
  },

  changePersonInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_PERSON_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeAffiliationInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_AFFILIATION_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeBasicArraysInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_BASICARRAYINPUT_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeReferenceInput:
    (...params) =>
    (dispatch) => {
      const actionData = {
        type: actionTypes.CHANGE_REFERENCE_INPUT,
        payload: params,
      };
      dispatch(actionData);
    },

  changeDateInput: (params) => ({
    type: actionTypes.CHANGE_DATE_INPUT,
    payload: { publishedDate: params, isDocumentEdited: true },
  }),

  addPerson: (params) => ({
    type: actionTypes.ADD_PERSON,
    payload: params,
  }),

  addAffiliation: (...params) => ({
    type: actionTypes.ADD_AFFILIATION,
    payload: params,
  }),

  updateAffiliationsAuthors: (params) => ({
    type: actionTypes.UPDATE_AFFILIATIONS_AUTHORS,
    payload: params,
  }),

  addBasicArrayInput: (...params) => ({
    type: actionTypes.ADD_BASICARRAYINPUT,
    payload: params,
  }),

  addReference: (...params) => ({
    type: actionTypes.ADD_REFERENCE,
    payload: params,
  }),

  removePerson: (params) => ({
    type: actionTypes.REMOVE_PERSON,
    payload: params,
  }),

  removeAffiliation: (...params) => ({
    type: actionTypes.REMOVE_AFFILIATION,
    payload: params,
  }),

  removeBasicArrayInput: (...params) => ({
    type: actionTypes.REMOVE_BASICARRAYINPUT,
    payload: params,
  }),

  removeReference:
    (...params) =>
    (dispatch) => {
      const [, uniqueId, references] = [...params];
      try {
        dispatch({
          type: actionTypes.REMOVE_REFERENCE,
          payload: [references, uniqueId],
        });
      } catch (err) {
        showError('Please try again deleting the reference');
      }
    },

  updateReferences: (params) => (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_REFERENCES,
      payload: params,
    });
  },

  updateAddReferenceFocusPoint:
    (...params) =>
    (dispatch) => {
      dispatch({
        type: actionTypes.UPDATE_ADD_REFERENCE_FOCUS_REFERENCES,
        payload: params,
      });
    },

  changeDocumentEditedStatus: () => (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_DOCUMENT_EDITED_STATUS,
      payload: {
        isDocumentEdited: false,
      },
    });
  },

  changeHistoryBackward:
    (...params) =>
    (dispatch) => {
      const [currentHistory] = [...params];
      if (!currentHistory.tail.prev) {
        return;
      }
      let { tail } = currentHistory;
      const temp = tail;
      tail = tail.prev;
      tail.next = temp;
      const history = {
        ...currentHistory,
        tail: {
          ...currentHistory.tail,
          ...tail,
        },
      };
      dispatch({
        type: actionTypes.CHANGE_HISTORY_BACKWARD,
        payload: {
          history,
        },
      });
    },

  changeHistoryForward:
    (...params) =>
    (dispatch) => {
      const [currentHistory] = [...params];
      if (!currentHistory.tail.next) {
        return;
      }
      let { tail } = currentHistory;
      const temp = tail;
      tail = tail.next;
      tail.prev = temp;
      const history = {
        ...currentHistory,
        tail: {
          ...currentHistory.tail,
          ...tail,
        },
      };
      dispatch({
        type: actionTypes.CHANGE_HISTORY_FORWARD,
        payload: {
          history,
        },
      });
    },

  addNewObjectToArray: (...props) => ({
    type: actionTypes.ADD_NEW_OBJECT_TO_ARRAY,
    ...props,
  }),

  saveData:
    (...params) =>
    (dispatch) => {
      dispatch({
        type: actionTypes.SAVE_DATA,
        payload: params,
      });
    },
  setCounterValue:
    (...params) =>
    (dispatch) => {
      dispatch({
        type: actionTypes.SET_COUNTER_VALUE,
        payload: params,
      });
    },
};

export default editJournalForm;
